import React from 'react';
import { Type, Image } from 'lucide-react';
import type { LogoMode, TabConfig } from './types';

interface TabNavigationProps {
  activeTab: LogoMode;
  onTabChange: (tab: LogoMode) => void;
}

const TABS: TabConfig[] = [
  { id: 'text', label: 'Text Only', icon: Type, desc: 'Use text as your logo' },
  { id: 'image', label: 'Image Only', icon: Image, desc: 'Upload a logo image' },
];

export const TabNavigation: React.FC<TabNavigationProps> = ({ activeTab, onTabChange }) => {
  return (
    <div className="flex border-b border-gray-200 bg-gray-50 flex-shrink-0">
      {TABS.map(tab => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`flex-1 px-6 py-4 text-left border-b-2 transition-all ${
            activeTab === tab.id
              ? 'border-blue-500 bg-white text-blue-600'
              : 'border-transparent hover:bg-gray-100 text-gray-600'
          }`}
        >
          <div className="flex items-center space-x-3">
            <tab.icon size={20} />
            <div>
              <div className="font-medium">{tab.label}</div>
              <div className="text-xs opacity-75">{tab.desc}</div>
            </div>
          </div>
        </button>
      ))}
    </div>
  );
};
